import CurrentUserRepository from '../../domain/repository/CurrentUserRepository';
import CurrentUserStore from '../../domain/store/CurrentUserStore';
import { ZopimHandler } from '../../infrastructure/adapter/ZopimHandler';
import config from '../../config';

export class AuthenticationUsecase {
  private currentUserRepository: CurrentUserRepository;
  private currentUserStore: CurrentUserStore;
  private zopimHandler: ZopimHandler;

  constructor({
    currentUserRepository,
    currentUserStore,
    zopimHandler,
  }: {
    currentUserRepository: CurrentUserRepository;
    currentUserStore: CurrentUserStore;
    zopimHandler: ZopimHandler;
  }) {
    this.currentUserRepository = currentUserRepository;
    this.currentUserStore = currentUserStore;
    this.zopimHandler = zopimHandler;
  }

  public async authenticate() {
    const { currentUserRepository, currentUserStore, zopimHandler } = this;
    const user = await currentUserRepository.getCurrentUser().catch(err => {
      window.location.assign(`${config.dashboard}/login?.done=${window.location}`);
      (window as any).Bugsnag.user = {};
      throw err;
    });
    currentUserStore.setCurrentUser(user);
    (window as any).Bugsnag.user = { ...currentUserStore.currentUser };
    zopimHandler.setUser({
      name: currentUserStore.currentUser.username,
      email: currentUserStore.currentUser.email,
    });
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/AuthenticationUsecase.ts